"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty2 = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty2(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-property"));

var _defineProperties = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-properties"));

var _getOwnPropertyDescriptors = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors"));

var _getOwnPropertyDescriptor = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor"));

var _getOwnPropertySymbols = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _get2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/get"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _defineProperty3 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _config = _interopRequireDefault(require("../../../../../targets/cord_eurofh_teams/config.js"));

var _cssConstants = _interopRequireDefault(require("../../../../../targets/cord_eurofh_teams/cssConstants.js"));

var _Nugget = _interopRequireDefault(require("./Nugget.scss"));

var _DrupalPodcastNugget = _interopRequireDefault(require("./DrupalPodcastNugget.scss"));

var _KESI2BasicComponent = _interopRequireDefault(require("../../../../KESI2/KESI2BasicComponent"));

var _KesiConstants = require("../../../../KESI2/KesiConstants");

var _DataStore = _interopRequireWildcard(require("../../../../KESI2/Stores/DataStore2"));

var _KESI2Helper = _interopRequireWildcard(require("../../../../KESI2/KESI2Helper"));

var _reactFontawesome = _interopRequireDefault(require("react-fontawesome"));

var _ArrayHelper = require("../../../../helpers/ArrayHelper");

var _DeviceInfoHelper = _interopRequireDefault(require("../../../../helpers/DeviceInfoHelper"));

var _PodcastNugget = _interopRequireDefault(require("../../../../KESI2/entities/nuggets/PodcastNugget"));

var _StringHelper = _interopRequireDefault(require("../../../../helpers/StringHelper"));

var _Button = _interopRequireDefault(require("../../Button"));

var _AudioPlayer = _interopRequireDefault(require("../../AudioPlayer/AudioPlayer2"));

var _AudioPlayer2 = _interopRequireDefault(require("../../AudioPlayer/AudioPlayer"));

var _Image = _interopRequireDefault(require("../../Image/Image"));

function ownKeys(object, enumerableOnly) { var keys = (0, _keys["default"])(object); if (_getOwnPropertySymbols["default"]) { var symbols = (0, _getOwnPropertySymbols["default"])(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return (0, _getOwnPropertyDescriptor["default"])(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty3["default"])(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors["default"]) { (0, _defineProperties["default"])(target, (0, _getOwnPropertyDescriptors["default"])(source)); } else { ownKeys(Object(source)).forEach(function (key) { (0, _defineProperty2["default"])(target, key, (0, _getOwnPropertyDescriptor["default"])(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

var DOM_PREFIX = 'podcastContainer_';

var DrupalPodcastNugget = /*#__PURE__*/function (_Kesi2BasicComponent) {
  (0, _inherits2["default"])(DrupalPodcastNugget, _Kesi2BasicComponent);

  var _super = _createSuper(DrupalPodcastNugget);

  function DrupalPodcastNugget(props, context) {
    var _thisSuper, _this;

    (0, _classCallCheck2["default"])(this, DrupalPodcastNugget);
    _this = _super.call(this, props, context, props.id);
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "getDomId", function () {
      return "".concat(DOM_PREFIX).concat(_this.props.id);
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "subscribeToTopic", function (topic, isSubscribe) {
      var subscriptions = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.PODCAST_SUBSCRIPTIONS) || [];
      var index = subscriptions.indexOf(topic);

      if (index === -1 && isSubscribe) {
        subscriptions.push(topic);

        _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.PODCAST_SUBSCRIPTIONS, subscriptions);
      } else if (index > -1 && !isSubscribe) {
        (0, _ArrayHelper.removeElementAtPosition)(subscriptions, index);

        _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.PODCAST_SUBSCRIPTIONS, subscriptions);
      }
    });
    _this.state = _objectSpread({
      waitingForActivation: false,
      waitingForDelete: false,
      checkedBoxes: [],
      mobilePageIndex: 0,
      currentlyPlayingTitle: null,
      currentlyPlayingIndex: 0,
      audioIsPlaying: false
    }, _this.state); // the nugget will be put there on a magic way by Reflux and props.id which is given in the constructor

    _this.audioElement = null;
    _this.listenedSequences = null;
    _this.domId = _StringHelper["default"].createShortId();
    _this.active = true;

    _this.props.registerNugget(_this.props.id, _PodcastNugget["default"].CLASS, _this.getDomId(), _this.props.inSwipeContainer || _this.props.inGalleryContainer || _this.props.inListContainer);

    (0, _get2["default"])((_thisSuper = (0, _assertThisInitialized2["default"])(_this), (0, _getPrototypeOf2["default"])(DrupalPodcastNugget.prototype)), "setDataStorePaths", _thisSuper).call(_thisSuper, [_DataStore.DATA_STORE_PATHS.KESI_ALL_LIKES, _DataStore.DATA_STORE_PATHS.KESI_VISIBILITIES, _DataStore.DATA_STORE_PATHS.KESI_ADDITIONAL_DATA, _DataStore.DATA_STORE_PATHS.KESI_LIKES]);
    return _this;
  }

  (0, _createClass2["default"])(DrupalPodcastNugget, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.registerNuggetPosition(this.props.id, _PodcastNugget["default"].CLASS, this.getDomId());

      if (this.props.inListContainer) {
        this.props.setBackButtonFunc(this.props.goUpFunc);
      }
    }
    /**
     * @return {PodcastNugget}
     */

  }, {
    key: "getNugget",
    value: function getNugget() {
      return this.state.content[this.props.id];
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, snapshot) {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(DrupalPodcastNugget.prototype), "componentDidUpdate", this).call(this, prevProps, prevState, snapshot);
      var nugget = this.state.content[prevProps.id];
      var active = _DataStore["default"].pathExists("".concat(prevProps.id, ".").concat(prevProps.contentPathArray.join(_KesiConstants.KESI_PATH_DELIMITER)), this.state.data[_DataStore.DATA_STORE_PATHS.KESI_VISIBILITIES]) ? this.state.data[_DataStore.DATA_STORE_PATHS.KESI_VISIBILITIES][prevProps.id][prevProps.contentPathArray.join(_KesiConstants.KESI_PATH_DELIMITER)] : nugget.active;

      if (this.state.waitingForActivation && active !== this.active) {
        this.setState({
          waitingForActivation: false
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      /**
       * @type {PodcastNugget}
       */
      var nugget = this.state.content[this.props.id];
      var active = _DataStore["default"].pathExists("".concat(_DataStore.DATA_STORE_PATHS.KESI_VISIBILITIES, ".").concat(this.props.id, ".").concat(this.props.contentPathArray.join(_KesiConstants.KESI_PATH_DELIMITER))) ? this.state.data[_DataStore.DATA_STORE_PATHS.KESI_VISIBILITIES][this.props.id][this.props.contentPathArray.join(_KesiConstants.KESI_PATH_DELIMITER)] || nugget.active : nugget.active;
      var innerClassNames = !active && !(0, _KESI2Helper.isKesiMaster)() ? "".concat(_Nugget["default"].innerHidden) : '';
      var outerClassNames = !active && !(0, _KESI2Helper.isKesiMaster)() ? "".concat(_Nugget["default"].outerHidden) : '';
      var likes = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.KESI_LIKES) || [];
      var likeIndex = likes.indexOf(this.props.id);
      var allLikes = this.state.data[_DataStore.DATA_STORE_PATHS.KESI_ALL_LIKES];
      var currentLikesForId = allLikes && allLikes["".concat(this.props.id)] ? allLikes["".concat(this.props.id)] : 0;

      var isAuthor = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.KESI_SHOW_UNPUBLISHED_CONTENT);

      var backgroundColor = this.props.lectureBackgroundColor && _cssConstants["default"].colorMap ? _cssConstants["default"].colorMap[this.props.lectureBackgroundColor] : _cssConstants["default"].colors.buttonBackground;
      var podcastSubscriptions = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.PODCAST_SUBSCRIPTIONS) || [];
      console.log('podcastNugget', nugget);
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "podcastContainer ".concat(_DeviceInfoHelper["default"].isBrowser() ? '' : 'mobile', " ").concat(this.getDomId(), " ").concat(_Nugget["default"].outerContainer, " ").concat(outerClassNames),
        id: this.getDomId(),
        style: this.props.inSwipeContainer || this.props.inListContainer || this.props.inGalleryContainer ? {
          width: '100%',
          padding: 0,
          margin: 0
        } : {}
      }, _config["default"].showNuggetIcons ? this.props.renderIcon(nugget) : null, /*#__PURE__*/_react["default"].createElement("div", {
        className: "podcastNugget_".concat(this.props.id, " ").concat(_Nugget["default"].container, " ").concat(innerClassNames)
      }, isAuthor && !nugget.isPublished && /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          padding: '10px',
          color: 'red'
        }
      }, "Content unver\xF6ffentlicht"), nugget.show_title ? /*#__PURE__*/_react["default"].createElement("div", {
        className: "ctnPodcastTitle ".concat(this.props.inGalleryContainer ? 'titleSmall' : 'title')
      }, nugget.title) : null, nugget.audios && nugget.audios.length > 0 && window.Media && /*#__PURE__*/_react["default"].createElement(_AudioPlayer["default"], {
        backgroundColor: backgroundColor,
        currentlyPlayingIndex: this.state.currentlyPlayingIndex,
        domId: this.domId,
        playlist: nugget.audios,
        nugget: nugget,
        background: nugget.background,
        barColor: backgroundColor,
        info: nugget.info
      }), nugget.audios && nugget.audios.length > 0 && !window.Media && /*#__PURE__*/_react["default"].createElement(_AudioPlayer2["default"], {
        backgroundColor: backgroundColor,
        currentlyPlayingIndex: this.state.currentlyPlayingIndex,
        domId: this.domId,
        playlist: nugget.audios,
        nugget: nugget,
        background: nugget.background,
        barColor: backgroundColor,
        info: nugget.info
      })), _config["default"].allowPodcastSubscriptions && nugget.topic ? /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", null, podcastSubscriptions.indexOf(nugget.topic) === -1 ? "M\xF6chten Sie eine Benachrichtigungen erhalten, sobald eine neue Folge zum Themengebiet \"".concat(nugget.topic, "\" verf\xFCgbar ist?") : "Sie haben das Themengebiet ".concat(nugget.topic, " bereits abonniert. Sie k\xF6nnen in den App-Einstellungen das Abo jederzeit beenden.")), podcastSubscriptions.indexOf(nugget.topic) === -1 ? /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        className: _DrupalPodcastNugget["default"].subscribeButton,
        onClick: function onClick() {
          _this2.subscribeToTopic(nugget.topic, true);
        }
      }, "".concat(nugget.topic, " abonnieren")) : /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        className: _DrupalPodcastNugget["default"].subscribeButton,
        onClick: function onClick() {
          _this2.subscribeToTopic(nugget.topic, false);
        }
      }, "".concat(nugget.topic, " nicht mehr abonnieren"))) : null, _config["default"].hasLikeFunctionalityForNuggets && !this.props.inSwipeContainer && !this.props.inListContainer && !this.props.inGalleryContainer ? /*#__PURE__*/_react["default"].createElement("div", {
        className: _Nugget["default"].likeContainer
      }, _config["default"].useTargetIcons ? /*#__PURE__*/_react["default"].createElement(_Image["default"], {
        className: _Nugget["default"].svgLikeButton,
        onClick: function onClick() {
          return _this2.props.setLike();
        },
        src: likeIndex < 0 ? _config["default"].likeInactive : _config["default"].likeActive
      }) : /*#__PURE__*/_react["default"].createElement(_reactFontawesome["default"], {
        onClick: function onClick() {
          return _this2.props.setLike();
        },
        className: likeIndex < 0 ? _Nugget["default"].likeButton : _Nugget["default"].likeButtonActivated,
        name: 'thumbs-o-up'
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: _Nugget["default"].likeText
      }, "".concat(currentLikesForId, " ").concat(currentLikesForId === 1 ? 'Like' : 'Likes'))) : null);
    }
  }]);
  return DrupalPodcastNugget;
}(_KESI2BasicComponent["default"]);

exports["default"] = DrupalPodcastNugget;
DrupalPodcastNugget.propTypes = {
  id: _propTypes["default"].string.isRequired,
  path: _propTypes["default"].string,
  registerNugget: _propTypes["default"].func.isRequired,
  markAsRead: _propTypes["default"].func.isRequired,
  contentPathArray: _propTypes["default"].array.isRequired,
  inSwipeContainer: _propTypes["default"].bool.isRequired,
  inListContainer: _propTypes["default"].bool.isRequired,
  inGalleryContainer: _propTypes["default"].bool.isRequired,
  goUpFunc: _propTypes["default"].func,
  forcedUIColor: _propTypes["default"].string,
  renderIcon: _propTypes["default"].func.isRequired,
  registerSendFunc: _propTypes["default"].func,
  lectureBackgroundColor: _propTypes["default"].string,
  setLike: _propTypes["default"].func
};
DrupalPodcastNugget.defaultProps = {
  id: null
};